import {defineStore} from 'pinia';
import api from '@/api/api';

export const useLogsStore = defineStore('logs', {
    state: () => {
        return {
            hasPermission: false,
            isPermissionAlreadyQueried: false,
        }
    },
    getters: {},
    actions: {
        async init() {
            await this.verifyShouldNavigateToLogsPage();
        },

        canAccessLogs() {
            return this.hasPermission;
        },

        async verifyShouldNavigateToLogsPage() {
            if (this.isPermissionAlreadyQueried) {
                return;
            }

            await api().get('/log/permission', {})
                .then(() => this.hasPermission = true)
                .catch(() => this.hasPermission = false)
                .finally(() => this.isPermissionAlreadyQueried = true);
        },

        reset() {
            this.hasPermission = false;
            this.isPermissionAlreadyQueried = false;
        }
    },
    persist:
        [
            {pick: ['hasPermission', 'isPermissionAlreadyQueried'], storage: localStorage},
        ],
});